import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const FaqAccordion = ({ items, dark = false, testidPrefix = "faq" }) => {
  const [openIdx, setOpenIdx] = useState(null);
  return (
    <div className={`border-t ${dark ? "border-white/15" : "border-charcoal/15"}`} data-testid={`${testidPrefix}-list`}>
      {items.map((item, i) => {
        const open = openIdx === i;
        return (
          <div key={i} className={`border-b ${dark ? "border-white/15" : "border-charcoal/15"}`}>
            <button
              onClick={() => setOpenIdx(open ? null : i)}
              data-testid={`${testidPrefix}-item-${i}`}
              aria-expanded={open}
              className="w-full flex items-start justify-between gap-6 py-6 text-left group"
            >
              <span
                className={`font-serif text-xl lg:text-2xl font-medium leading-snug transition-colors duration-300 ${
                  open ? "text-golddark" : dark ? "text-ivory group-hover:text-gold" : "text-charcoal group-hover:text-golddark"
                }`}
              >
                {item.q}
              </span>
              <span
                className={`mt-1.5 shrink-0 text-lg leading-none transition-[color,transform] duration-300 ${
                  open ? "text-gold rotate-45" : dark ? "text-ivory/50" : "text-charcoal/50"
                }`}
              >
                +
              </span>
            </button>
            <AnimatePresence initial={false}>
              {open && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                >
                  <p
                    className={`pb-7 pr-10 text-sm lg:text-base leading-relaxed max-w-3xl ${
                      dark ? "text-ivory/70" : "text-charcoal/70"
                    }`}
                    data-testid={`${testidPrefix}-answer-${i}`}
                  >
                    {item.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
};
